import { render, staticRenderFns } from "./vue-signature.vue?vue&type=template&id=3ecfee64"
import script from "./vue-signature.vue?vue&type=script&lang=js"
export * from "./vue-signature.vue?vue&type=script&lang=js"
import style0 from "./vue-signature.vue?vue&type=style&index=0&id=3ecfee64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports